import { GET_REGISTERED_USERS, SET_NEW_USERS, GET_QUALIFICATIONS, REMOVE_USER } from "./types";
import firebase from "firebase/app";
// import { selectFirebaseConfig } from "vrcore-dashboard/dist/utilities";
import "firebase/functions";

export const getRegisteredUsers = () => {
    return dispatch => {
        dispatch({ type: GET_REGISTERED_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_REGISTERED_USERS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/users")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REGISTERED_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REGISTERED_USERS.FAIL });
        }
    };
};
export const getQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_QUALIFICATIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_QUALIFICATIONS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/required_qualifications")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_QUALIFICATIONS.FAIL });
        }
    };
};

export const setNewUser = (newuser, password, callback) => {
    return dispatch => {
        dispatch({ type: SET_NEW_USERS.REQUEST });

        let cloudFunction = firebase.functions().httpsCallable("addUser");
        try {
            cloudFunction(newuser, password).then(e => {
                dispatch({ type: SET_NEW_USERS.SUCCESS, payload: false });
                callback(true);
            });
        } catch (e) {
            dispatch({ type: SET_NEW_USERS.FAIL });
            callback(false);
        }
    };
};
export const removeUser = (uid, callback) => {
    return dispatch => {
        dispatch({ type: REMOVE_USER.REQUEST, payload: true });
        let cloudFunction = firebase.functions().httpsCallable("removeUser");
        try {
            cloudFunction(uid).then(e => {
                dispatch({ type: REMOVE_USER.SUCCESS, payload: false });
                callback(true);
            });
        } catch (e) {
            dispatch({ type: REMOVE_USER.FAIL });
            callback(false);
        }
    };
};
